import React from "react";
import { Activity, Sparkles } from "lucide-react";
import SearchBar from "@/components/SearchBar";
import { TID } from "@/lib/testIds";

export default function Header({ onSelect, hasStock, updatedAt }) {
  return (
    <header
      data-testid={TID.header}
      className="sticky top-0 z-40 bg-zinc-950/80 backdrop-blur-xl border-b border-zinc-800"
    >
      <div className="max-w-[1600px] mx-auto flex items-center gap-4 px-4 sm:px-6 lg:px-8 py-3.5">
        <div
          data-testid={TID.headerLogo}
          className="flex items-center gap-2.5 shrink-0"
        >
          <div className="relative w-8 h-8 rounded-md bg-gradient-to-br from-blue-600 to-blue-500 flex items-center justify-center">
            <Activity className="w-4 h-4 text-white" strokeWidth={2.2} />
            <span className="absolute -bottom-0.5 -right-0.5 w-2 h-2 rounded-full bg-emerald-400 pulse-dot" />
          </div>
          <div className="leading-tight hidden sm:block">
            <div className="text-[13px] font-bold tracking-tight text-white">
              AI Stock Research
            </div>
            <div className="text-[10px] uppercase tracking-[0.14em] text-zinc-500">
              Dashboard · Beta
            </div>
          </div>
        </div>

        {hasStock && (
          <div className="flex-1 max-w-xl ml-2">
            <SearchBar compact onSelect={onSelect} />
          </div>
        )}

        <div className="ml-auto flex items-center gap-3 shrink-0">
          <div className="hidden md:flex items-center gap-2 text-xs text-zinc-500 font-mono">
            <span className="inline-flex w-1.5 h-1.5 rounded-full bg-emerald-400 blink" />
            LIVE
          </div>
          <div className="hidden sm:block text-xs font-mono text-zinc-500">
            {updatedAt ? updatedAt : ""}
          </div>
          <div className="hidden lg:flex items-center gap-1.5 text-xs text-blue-400 bg-blue-500/10 border border-blue-500/20 px-2 py-1 rounded-md">
            <Sparkles className="w-3 h-3" strokeWidth={2} />
            <span className="font-semibold">Claude 4.5</span>
          </div>
        </div>
      </div>
    </header>
  );
}
